import React from "react";
import  { useDispatch, useSelector } from "react-redux";
import { Blade, Button, ProgressIndicator } from "rhombus-react";

import useActiveCreative from "hooks/useActiveCreative";

import { closeModal } from 'reducers/Modal';
import { bulkStatusChange } from 'reducers/Creatives';

import { isYouTube } from "utils/CreativeActions";
import { copyToClipboard, labelWithCount } from "utils/common";

import CreativesTable from 'widgets/table/CreativesTable';
import YouTubeToS from "widgets/modals/creatives/social/YouTubeToS";

import { addNotification } from "reducers/Notifications";

import "./ApproveCreatives.css";


export default function ApproveCreatives(props){
	let dispatch = useDispatch()
		, { creatives = [], libraryId } = props
		, anyYouTube = creatives.some(creative => isYouTube(creative.adType))
		, s = creatives.length > 1 ? 's' : '' // eslint-disable-line
		, modalTitle = `Approve Creative${s}`
		, { isUpdating } = useSelector(state => ({
			isUpdating: state.creatives.isUpdating,
		}))
		, onClose = () => dispatch(closeModal())
		, onSubmit = () => {
			dispatch(bulkStatusChange({
				status: 'approve',
				libraryId,
				creativeIds: creatives.map(creative => creative.id),
				reason: null,
			})).then((response) => {
				if (response?.success) {
					return dispatch(closeModal());
				}
			});
		}
		;

	if (creatives.length > 1) {
		modalTitle = `Approve Creatives - ${creatives.length} Creatives`;
	} else if (creatives.length === 1) {
		modalTitle = `Approve Creative - ${creatives[0].name}`;
	}

	useActiveCreative(creatives[0]?.id);

	const handleCopy = () => {
		const names = creatives.map(creative => creative.name).join("\n");

		copyToClipboard(names)
			.then(() => {
				dispatch(addNotification({
					type: "success",
					messageHeader: "Copy Names",
					message: "Creative Names Copied",
				}));
			});
	};

	const renderContent = () => (
		<div className="approve-creative-content">
			<ProgressIndicator isLoading={isUpdating} />
			<p className="approve-creative-heading">
				<strong>{`Are you sure you want to approve the selected creative${s}?`}</strong>
			</p>
			<CreativesTable shouldLinkPreview={false} creatives={creatives} />
			{anyYouTube ? <YouTubeToS label={`Approve Creative${s}`} /> : null}
		</div>
	);

	const renderFooter = () => ([
		<Button key="cancel" theme="grey" disabled={isUpdating} onClick={onClose}>Cancel</Button>,
		<div key="right-buttons" className="right-buttons">
			<Button key="copy" onClick={handleCopy}>Copy Names</Button>
			<Button key="submit" theme="green" disabled={isUpdating} onClick={onSubmit}>
				{labelWithCount(`Approve Creative${s}`, creatives.length)}
			</Button>
		</div>
	]);

	return (
		<Blade
			type="modal"
			setAppTitle={false}
			className="approve-creative"
			title={modalTitle}
			allowFullScreen={false}
			xClose
			bladeProps={{ verticallyCenter: true }}
			onClose={onClose}
			renderContent={renderContent}
			renderFooter={renderFooter}
		/>
	);
}

ApproveCreatives.displayName = "ApproveCreatives";
